import CommandCheckboxes from "@/components/commands/command-checkboxes";
import type { FilterDefinitionValue } from "@/pages/(app)/returns/hooks/use-filter-definitions";
import { StringFrontFilterValue } from "@/pages/(app)/returns/providers/return-requests-filters.provider";
import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import { StringFilterName } from "../../utils/types";

interface StringArrayFilterCommandProps {
  filterDefinition: FilterDefinitionValue;
  filter?: StringFrontFilterValue;
  filterKey: StringFilterName;
}

export default function StringArrayFilterCommand({
  filterDefinition,
  filter,
  filterKey,
}: StringArrayFilterCommandProps) {
  const { addFilter, removeFilter, clearFilter, setQuickFilter } =
    useReturnRequestsFilters();
  const condition = filter?.condition ?? "in";
  const values = filter?.value ?? [];
  const options = Array.from(filterDefinition.options.values());

  return (
    <CommandCheckboxes
      options={options.map((option) => {
        const isSelected = !!filter?.value.includes(option.value);

        return {
          ...option,
          isSelected,
        };
      })}
      values={values}
      onSelect={(value, isSelected) => {
        if (filterKey === "status") {
          setQuickFilter(null);
        }
        if (!isSelected) {
          addFilter({
            name: filterKey,
            value,
            condition,
            isMulti: true,
          });
        } else {
          removeFilter({
            name: filterKey,
            value,
            condition,
            isMulti: true,
          });
        }
      }}
      onClear={() => {
        clearFilter({ name: filterKey });
      }}
      inputPlaceholder={filterDefinition.category.label + "..."}
    />
  );
}
